import { render, staticRenderFns } from "./AddEmployer.vue?vue&type=template&id=3fb89023&"
import script from "./AddEmployer.vue?vue&type=script&lang=js&"
export * from "./AddEmployer.vue?vue&type=script&lang=js&"
import style0 from "./AddEmployer.vue?vue&type=style&index=0&id=3fb89023&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports